import React from "react";
import { useFormRVEO } from "./hooks/useFormRVEO";
import { NavForm } from "./FormElements/NavForm";
import { ModalFormBeneficiaries } from "./ModalFormBeneficiaries";
import { ModalitiesForm } from "./modalitiesForm";
import { NavFormMobile } from "./FormElements/NavMobile";
import ShowFormActive from "./FormElements/ShowFormActive";
import { MODALITIES } from "../Utils/constants";

interface RVFormInterface {
  investmentProfile: string;
  onClick: () => void;
  isError: boolean;
  dataState: any;
  submitValues: any;
  close: () => void;
}

export const FormRVHook = ({
  dataState,
  investmentProfile,
  isError,
  close,
}: RVFormInterface) => {
  const {
    afpData,
    handleSubmit,
    register,
    errors,
    saludData,
    serviceData,
    coverageData,
    activeStep,
    showModalAddBeneficiarie,
    showModalMod,
    stepsForm,
    parients,
    deleteParient,
    relationshipData,
    handleOpenModalEditBeneficiarie,
    selectedParient,
    handleOpenModalAddBeneficiaries,
    handleAddBeneficiarie,
    handleCloseModalBeneficiarie,
    registerFinancial,
    capitalPension,
    showTitleActive,
    nextActiveStep,
    prevActiveStep,
    handleSubmitBeneficiarie,
    registerBeneficiarie,
    registerModalitie,
    modalitiesSelect,
    currencyData,
    setValueModalitie,
    deferredYears,
    prestacionWatch,
    modalities,
    selectSalud,
    averageRenum,
    containerFormRef,
    errorsModalitie,
    errorsBeneficiarie,
    genrerData,
    deleteModalitie,
    handleOpenModalAddModalities,
    handleCloseModalModalities,
    handleOpenModalEditModalitie,
    modalitiesOptions,
    tempYearsData,
    guaranteedYearsData,
    setValueFinancial,
    methodFinancial,
    relationshipBeneficiarie,
    bornDateBeneficiarie,
    saludBeneficiarie,
    genrerBenefiarie,
    setValueBeneficiarie,
    currencyMod,
    defYearsMod,
    tempYearsMod,
    guarYearsMod,
    handleSubmitFinancial,
    selectedModalitie,
    handleAddModalitie,
    handleSubmitModalitie,
    dateDevOrig,
    dateDeven,
    objSendForm,
    setObjSendForm,
    renderName,
    formatCurrency,
    disabledStepGeneral,
    getFilteredRelationshipData,
    validationAverageProm,
    handleSubmitForm,
    assured,
    loadingSubmit,
  } = useFormRVEO();

  return (
    <div className="productRV__container">
      <NavFormMobile
        position={Number(activeStep.id)}
        title={showTitleActive(activeStep.id)}
        subtitle=" "
        hidden={true}
        handleBack={() => {
          if (activeStep.id === 1) {
            close();
          }
          prevActiveStep(activeStep.id);
        }}
        total={stepsForm.length}
      />
      <NavForm
        title={showTitleActive(activeStep.id)}
        onClick={() => {}}
        steps={stepsForm}
        activeStep={activeStep}
        onBack={() => {
          if (activeStep.id === 1) {
            close();
          }
          prevActiveStep(activeStep.id);
        }}
      />
      <div ref={containerFormRef} className="productRV__container-form">
        {activeStep && (
          <ShowFormActive
            stepActive={activeStep.id}
            assured={assured}
            serviceData={serviceData}
            register={register}
            objSendForm={objSendForm}
            afpData={afpData}
            prestacionWatch={prestacionWatch}
            selectSalud={selectSalud}
            coverageData={coverageData}
            validationAverageProm={validationAverageProm}
            averageRenum={averageRenum}
            handleSubmit={handleSubmit}
            nextActiveStep={nextActiveStep}
            setObjSendForm={setObjSendForm}
            disabledStepGeneral={disabledStepGeneral}
            methodFinancial={methodFinancial}
            handleSubmitFinancial={handleSubmitFinancial}
            setValueFinancial={setValueFinancial}
            registerFinancial={registerFinancial}
            errors={errors}
            formatCurrency={formatCurrency}
            capitalPension={capitalPension}
            dateDevOrig={dateDevOrig}
            dateDeven={dateDeven}
            handleOpenModalAddBeneficiaries={handleOpenModalAddBeneficiaries}
            parients={parients}
            relationshipData={relationshipData}
            saludData={saludData}
            genrerData={genrerData}
            renderName={renderName}
            handleOpenModalEditBeneficiarie={handleOpenModalEditBeneficiarie}
            deleteParient={deleteParient}
            handleOpenModalAddModalities={handleOpenModalAddModalities}
            modalities={modalities}
            handleOpenModalEditModalitie={handleOpenModalEditModalitie}
            deleteModalitie={deleteModalitie}
            handleSubmitForm={(request: any) => handleSubmitForm(request, dataState)}
            loadingSubmit={loadingSubmit}
          />
        )}
      </div>
      <ModalFormBeneficiaries
        close={handleCloseModalBeneficiarie}
        onSubmit={handleSubmitBeneficiarie((parient) => {
          handleAddBeneficiarie(parient);
        })}
        errors={errorsBeneficiarie}
        open={showModalAddBeneficiarie}
        register={registerBeneficiarie}
        setValue={setValueBeneficiarie}
        relationship={getFilteredRelationshipData()}
        selectedParient={selectedParient}
        genrer={genrerData}
        disabledGenrer={relationshipBeneficiarie === "C" || relationshipBeneficiarie === "T"}
        salud={saludData.filter((salud: any) => salud.value !== "Invalidez Parcial")}
        disabledSend={
          !(
            relationshipBeneficiarie &&
            bornDateBeneficiarie &&
            saludBeneficiarie &&
            genrerBenefiarie
          )
        }
      />
      <ModalitiesForm
        title={selectedModalitie ? "Editar Modalidad" : "Agregar Modalidad"}
        onSubmit={handleSubmitModalitie((mod) => handleAddModalitie(mod))}
        open={showModalMod}
        close={handleCloseModalModalities}
        modData={modalitiesOptions}
        register={registerModalitie}
        modalitiesSelect={modalitiesSelect}
        selectedModalitie={selectedModalitie}
        setValueModalitie={setValueModalitie}
        currency={
          objSendForm && objSendForm.prestacion === "Jubilación"
            ? currencyData.slice(1)
            : currencyData
        }
        deferredYears={deferredYears}
        tempYears={tempYearsData}
        guaranteedYears={guaranteedYearsData}
        errors={errorsModalitie}
        disableSend={
          !modalitiesSelect ||
          !currencyMod ||
          (modalitiesSelect === MODALITIES.RENTA_VITALICIA && !guarYearsMod) ||
          (modalitiesSelect === MODALITIES.RENTA_VITALICIA_ESCALONADA && (!guarYearsMod || !tempYearsMod)) ||
          (modalitiesSelect === MODALITIES.RENTA_TEMPORAL_VITALICIA_DIFERIDA && (!guarYearsMod || !defYearsMod))
        }
      />
    </div>
  );
};
        